import React from 'react';
import { FcInvite } from 'react-icons/fc';
import Card from './Card';

function GiftsCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="ثبت معرف" icon={FcInvite}>
        </Card>
    );
}
export default GiftsCard;